// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__1IAPt","full-page":"style_full-page__P5uuB"};